const DiscountTag = ({ children, classNames }) => {
  return <div className={`block bg-infoCyan rounded-sm ${classNames}`}>{children}</div>;
};

export default DiscountTag;
